import { Brand } from '@blade/std-lib'

export const TxHashTypeId = 'tradebot-tma/TxHash'
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type TxHashTypeId = typeof TxHashTypeId

export type TxHash = Brand.Branded<string, TxHashTypeId>
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TxHash = Brand.nominal<TxHash>()
